/*
 * GO Commerce Debug Tools
 * 
 * This file contains utilities for debugging the application in development environments.
 * It exposes global functions for toggling debug panels and monitoring components.
 */

// Create a simple event system for debug tools
class DebugEventBus {
  private events: Record<string, Function[]> = {};

  public on(event: string, callback: Function) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  public emit(event: string, data?: any) {
    if (!this.events[event]) return;
    this.events[event].forEach(callback => callback(data));
  }
}

// Create a global debug namespace
export class GoDebugTools {
  private static instance: GoDebugTools;
  private eventBus: DebugEventBus = new DebugEventBus();

  private constructor() {
    // Initialize with safe defaults
    this.setupGlobalAccess();
  }

  public static getInstance(): GoDebugTools {
    if (!GoDebugTools.instance) {
      GoDebugTools.instance = new GoDebugTools();
    }
    return GoDebugTools.instance;
  }

  private setupGlobalAccess() {
    if (typeof window !== 'undefined') {
      // Expose the toggle function globally
      (window as any).toggleCacheDebug = () => {
        this.eventBus.emit('toggle-cache-debug');
      };
      
      // Expose debug namespace
      (window as any).goDebug = {
        toggleCachePanel: () => this.eventBus.emit('toggle-cache-debug'),
        resetApiStats: () => this.eventBus.emit('reset-api-stats'),
        clearAllCache: () => this.eventBus.emit('clear-all-cache')
      };
      
      console.log('[Debug Tools] Debug tools initialized and global functions exposed');
    }
  }

  public onToggleCacheDebug(callback: Function) {
    this.eventBus.on('toggle-cache-debug', callback);
  }
  
  public onResetApiStats(callback: Function) {
    this.eventBus.on('reset-api-stats', callback);
  }
  
  public onClearAllCache(callback: Function) {
    this.eventBus.on('clear-all-cache', callback);
  }
}

// Initialize on import
const debugTools = GoDebugTools.getInstance();

export default debugTools;
